import { render } from "./InvoiceCreator.vue?vue&type=template&id=1f250253"
import script from "./InvoiceCreator.vue?vue&type=script&lang=js"
export * from "./InvoiceCreator.vue?vue&type=script&lang=js"
script.render = render

export default script